import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: process.env.REACT_APP_TRANSLATION_PATH,
    },
    load: "languageOnly",
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    nonExplicitSupportedLngs: true,
    react: {
      useSuspense: true,
    },
  });

export default i18n;
